export default __webpack_public_path__ + "static/media/combinator.792a0724.svg";